export default "__VITE_ASSET__f9984085__"